// src/App.js
import React, { useRef } from 'react';
import CloseIcon from '@mui/icons-material/Close';
import AppMain from './view/AppMain';
import { SnackbarProvider, closeSnackbar } from 'notistack';
import { IconButton } from '@mui/material';

/**
 * CostAv
 * IgnoLab.com의 최초 프로젝트. https://ignolab.com/costav
 * 사용자가 앱 사용을 통해 분할매수방식의 힘을 느끼며 사고실험을 할 수 있게 함.
 * 과거 일정기간 주가 데이터를 기초로하여 특정한 규칙에 의해 기계적으로 매수, 매도하는 경우 발생할 수 있는 수익 또는 손실을 계산함으로써 어떠한 규칙이 분할매수에 적합한지 사용자가 분석할 수 있게 함.
 * 특히 박스권에서 움직이는 종목에 대한 실험
 * 주가데이터를 캔들차트로 표현
 * 매수, 매도한 금액, 총액, 당시 손익, 최종 손익 등 출력
 * 과거 일정기간 주가 데이터는 사용자가 구글 sheet의 GOOGLEFINANCE(ticker, "all", startDate, endDate)를 사용하여 만든 데이터를 paste해서 입력
 * 초기 버전이므로 데이터는 저장하지 않지만, 규칙정보는 로컬스토리지 저장.
 * @returns 
 */

function App() {
  const snackbarRef = useRef(null);
  return (
    <React.Fragment>
      <SnackbarProvider
        ref={snackbarRef}
        disableWindowBlurListener={true}
        anchorOrigin={{vertical: 'top', horizontal: 'center'}}
        action={(snackbarId) => (
            <IconButton
                size="small"
                onClick={() => closeSnackbar(snackbarId)}
            >
                <CloseIcon fontSize="small"/>
            </IconButton>
        )}
      >
        <AppMain />
      </SnackbarProvider>
    </React.Fragment>
  );
}

export default App;

// 향후 로그인 등을 할 수도 있으므로 <AppMain />을 분리해 두자.


/*
Perl script (Proof of Concept)


my $minimalTradeTimes = 5; # 최소 거래 횟수. 이 횟수만큼 거래하지 않았다면 팔지 않음. 최소값=1, 최대값=10
my $buyInterval = 20; # 기본 매수 간격 (일 단위) 최소값=3, 최대값=40
my $buyAmount = 500000; # 기본 매수 금액 (원 단위) 최소값=10, 최대값=10,000,000
my $bullIntervalFactor = 0.8; # 이전 매수보다 올라가 있는 경우 매수 간격 조절 (0.8배) 최소값=0.3, 최대값=2.0
my $bearIntervalFactor = 1.5; # 이전 매수보다 떨어져 있는 경우 매수 간격 조절 (1.5배) 최소값=0.3, 최대값=2.0
my $avgDownFactorMax = 1.5; # 손실을 보고 있을 때 매수금액 증액 비율 최대값 (1.5배) 최소값=1.0, 최대값=3.0 : (1.5-1) * 손실비율. ex: (1.5-1) * 0.2 = 0.1 => 1.1배 매수.
my $acceptableChange = 0.05; # 매수 시점에서의 주가 변화 허용 범위 (5% 이내) 최소값=0.02, 최대값=1.0
my $suddenDropBuyThreshold = 0.15; # 급격한 하락에 대한 매수 기준 (15% 이내) 최소값=0.1, 최대값=0.5
my $suddenDropBuyFactor = 0.2; # 급격한 하락 시 매수 금액 조절 (0.2배) 최소값=0, 최대값=1.0. 이 기간이 코비드 기간처럼 장기화 될 수 있으므로 1보다 크지 말아야 한다. 값이 0이면 급격한 하락에 대한 매수는 하지 않음.
my $rollingHighPeriod = 5; # 롤링 최고가 기간 (5일) 최소값=1, 최대값=30. $suddenDropBuyThreshold 적용의 기준이 되는 값. 현재 가격이 $rollingHighPeriod 기간의 최고값 대비 $suddenDropBuyThreshold 만큼 떨어져 있는 경우 매수한다. 또한 급락매수한 경우 이 값과 동일한 기간 내에 다시 매수하지는 않는다.
my $exitOnProfit = 0.3; # 수익이 q 퍼센트 이상인 경우 전체 매도. 이 경우 수익이 30% 이상인 경우 전체 보유주식 매도 최소값=0.1, 최대값=3.0
my ( $partialSellOnProfit, $partialSellThreshold ) = (0.2, 0.25); # 수익이 x 퍼센트 이상인 경우 보유주식수의 y 퍼센트 매도하고 매수하지 않음. 이 경우 수익이 20% 이상인 경우 보유주식의 25% 매도하고 매수하지 않음
# (partialSellOnProfit, 최소값=0.1, 최대값=3.0) (partialSellThreshold, 최소값=0.1, 최대값=0.5)
# 만일 수익이 $partialSellOnProfit 이상이고 $exitOnProfit 보다 작은 상태가 계속 이어지면, 횡보한다는 의미이고, 그러면 계속 25%씩 매도하게 된다. 절대 매도 수는 점차 줄어들게 된다.
my $bullInterval = int($buyInterval * $bullIntervalFactor); # 이전 매수보다 올라가 있는 경우 매수 간격 조절 (0.8배)한 값
my $bearInterval = int($buyInterval * $bearIntervalFactor); # 이전 매수보다 떨어져 있는 경우 매수 간격 조절 (1.5배)한 값
my $minInterval = $bullInterval <= $bearInterval ? $bullInterval : $bearInterval; # 매수 간격의 최소값. while문에서 조건 검사를 최소화하기 위한 값.

my $summary = {
    price => 0,
    count => 0,
    amount => 0,
    profit => 0,
    amountBought => 0, # 총 매수 금액
    amountSold => 0, # 총 매도 금액
    deposit => 0, # 예수금.
    moneyAdded => 0, # 추가 입금.
};

my $indexStartDate; # 시작 날짜 인덱스
my $indexEndDate; # 마지막 날짜 인덱스

my @records = (); # {date, price, count, amount, close} count는 매수한 주식 수. 만일 음수이면 매도
my $stockData = readStockData($rollingHighPeriod);
my @dates = sort keys %$stockData;

# 첫 매수일, 종료일 찾기.
foreach my $idx (0..$#dates) {
    if($dates[$idx] eq $startDate) { $indexStartDate = $idx; }
    elsif($dates[$idx] eq $endDate) { $indexEndDate = $idx; }
}

if(!defined $indexStartDate || !defined $indexEndDate) {
    die "Start date or end date not found in stock data.";
}

if($indexStartDate + $buyInterval * 10 > $indexEndDate) {
    die "Not enough days for this experiment.";
}

# 첫 매수
my $firstDate = $dates[$indexStartDate];
my $lastBuy = buy($firstDate, $stockData, $buyAmount, $summary);
if(!defined $lastBuy) {
    die "Not enough volume to buy on $firstDate."; # 실제로 이러면 살만한 가치가 없는 주식임.
}
push @records, $lastBuy;
makeSummary($summary, \@records);

$lastBuy->{idx} = $indexStartDate;
my $idx = $indexStartDate;
my $suddenDropBuyIndex = 0; # 급락매수를 한 경우 최종 급락 매수일의 인덱스

while($idx < $indexEndDate) {
    if($idx >= $indexEndDate) {
        $idx = $indexEndDate; # 마지막 날짜
        print "Reached the end date $dates[$idx]. No more trades possible.\n";
        last; # 더 이상 거래할 수 없음
    }
    my $vref = $stockData->{$dates[$idx]};
    my $profitRate = $vref->{open} / $summary->{price} - 1;

    # 매도 먼저 확인. 매도할 때에는 매수 인터벌은 적용하지 않음. 수익률이 유일한 기준.
    if(@records > $minimalTradeTimes) {
        # 모두 팔아야 할지 확인.
        if($profitRate >= $exitOnProfit) {
            print "Selling all shares on $dates[$idx] happily.\n";
            last; # 저 아래에서 모두 팔기
        }
        # 부분 매도 확인.
        if($profitRate >= $partialSellOnProfit) {
            print "Partially selling shares on $dates[$idx].\n";
            my $sold = sell($dates[$idx], $stockData, int($summary->{count} * $partialSellThreshold), $summary);
            push @records, $sold;
            makeSummary($summary, \@records);
            $lastBuy = $sold;
            $lastBuy->{idx} = $idx;
            # 부분 매도 후 매수하지 않음.
            $idx++;
            next;
        }
    }

    my $interval = $idx - $lastBuy->{idx}; # 마지막 매수 이후 경과 일수

    # 최소 간격($minInterval) 이내에 급격히 하락한 경우에 대한 대응은 고려되지 않음.
    # 그런 경우는 "모르고 지나간 사건"이 되는 것임.
    # 분할매수 방식에서 그런 경우까지 다 고려해야 할까?

    my $amountToBuy;

    if($interval >= $minInterval) {
        my $buyToday = undef; # 오늘 매수 여부

        if($vref->{open} > int($lastBuy->{price} * (1 + $acceptableChange))) {
            # 주가가 일상범위 넘어 오르고 있다.
            if($bullInterval >= $interval) {
                $buyToday = 1; # 상승시 매수간격 설정과 같으므로 오늘 산다.
            }
            # 그렇지 않으면 다음날로 넘어가게 된다.
        }
        elsif($vref->{open} < int($lastBuy->{price} * (1 - $acceptableChange))) {
            if($interval >= $bearInterval) {
                # 주가가 일상범위 넘게 떨어지고 있고, 하락시 매수간격 설정과 같으므로 오늘 산다.
                $buyToday = 1;
            }
            # 그렇지 않으면 다음날로 넘어가게 된다.
        }
        else {
            # 주가가 허용 범위 내에 있다면 정기적으로 매수한다.
            if($interval >= $buyInterval) {
                $buyToday = 1;
            }
            # 그렇지 않으면 다음날로 넘어가게 된다.
        }

        if($buyToday) {
            if($profitRate < 0 && $avgDownFactorMax > 1) {
                $amountToBuy = int($buyAmount * (1 + ($avgDownFactorMax - 1) * abs($profitRate)));
            }
            else {
                $amountToBuy = $buyAmount;
            }
            my $bought = buy($dates[$idx], $stockData, $amountToBuy, $summary);
            if(defined $bought) {
                push @records, $bought;
                makeSummary($summary, \@records);
                $lastBuy = $bought;
                $lastBuy->{idx} = $idx; # 마지막 매수 날짜 인덱스 갱신
            }
        }
    }
    else {
        # 급락 확인 및 추가 매수.
        if( $suddenDropBuyFactor > 0 && $vref->{rollingHigh} > 0 && $vref->{open} < ($vref->{rollingHigh} * (1 - $suddenDropBuyThreshold)) && $idx - $suddenDropBuyIndex >= $rollingHighPeriod) {
            # 롤링 최고가 대비 급락한 경우
            my $amountToBuy = int($buyAmount * $suddenDropBuyFactor);
            my $bought = buy($dates[$idx], $stockData, $amountToBuy, $summary);
            if(defined $bought) {
                push @records, $bought;
                makeSummary($summary, \@records);
                # 급락 매수는 정기매수에 포함하지 않는다.
                #$lastBuy = $bought;
                #$lastBuy->{idx} = $idx; # 마지막 매수 날짜 인덱스 갱신
                $suddenDropBuyIndex = $idx;
            }
        }
    }

    $idx++; # 다음 날로 이동
}

# 마지막에는 모두 팔기
if($summary->{count} > 0) {
    # 마지막 처리에서 $idx 대신 $indexEndDate를 강제하면 안돼. 왜나하면, 수익률이 충분하면 그 이전에라도 전액 매도해야만 하니까.
    print "Selling all remaining shares on $dates[$idx].\n";
    my $sold = sell($dates[$idx], $stockData, $summary->{count}, $summary);
    push @records, $sold;
    makeSummary($summary, \@records);
    $lastBuy = $sold;
}

# 최종 결과 출력.
foreach my $record (@records) {
    if($record->{count} < 0) {
        my $plusCount = -$record->{count};
        my $plusAmount = -$record->{amount};
        printf("%s: Sold %d shares at %d, total amount: %d\n", $record->{date}, $plusCount, $record->{price}, $plusAmount);
    }
    else {
        printf("%s: Bought %d shares at %d, total amount: %d\n", $record->{date}, $record->{count}, $record->{price}, $record->{amount});
    }
}

print "Final Summary:\n";
my $profitPercent = 100 * $summary->{profit} / $summary->{moneyAdded};
if($summary->{count} == 0) {
    printf("Profit: %d(%.2f%%) from invested amount %d. Deposit: %d (No shares left)\n", $summary->{profit}, $profitPercent, $summary->{moneyAdded}, $summary->{deposit});
}
else {
    printf("Average Price: %d, Total Shares: %d, Total Amount: %d, Profit: %d(%.2f%%), Invested: %d, Deposit: %d\n",
        $summary->{price}, $summary->{count}, $summary->{amount}, $summary->{profit}, $profitPercent, $summary->{moneyAdded}, $summary->{deposit});
}
my $firstBuy = $records[0];
#my $diff = $lastBuy->{price} - $firstBuy->{price};
printf("Last price is %.2f%% of the first price bought.\n", 100 * $lastBuy->{price} / $firstBuy->{price});

###
sub makeSummary {
    my($summary, $records) = @_;
    return if(!defined $records || !@$records);

    my $amountBought = 0; # 실제로 매수한 금액.
    my $amountSold = 0;   # 실제로 매도한 금액.

    my($price, $count, $amount) = (0, 0, 0);
    foreach my $record (@$records) {
        $count += $record->{count};
        $amount += $record->{amount};

        if($record->{count} > 0) {
            $amountBought += $record->{amount}; # 매수한 금액만 합산
        }
        else {
            $amountSold += -$record->{amount}; # 매도한 금액만 합산
        }
    }

    $summary->{amountBought} = $amountBought;
    $summary->{amountSold} = $amountSold;

    if($count == 0) {
        $summary->{price} = 0;
        $summary->{count} = 0;
        $summary->{profit} = -$amount;
        $summary->{amount} = $amount;
        return;
    }
    $summary->{price} = $amount / $count;
    $summary->{count} = $count;
    $summary->{amount} = $amount;
}

###
sub sell {
    my ($date, $stockData, $count, $summary) = @_;
    my $vref = $stockData->{$date};
    my $price = midPrice($vref);
    if($count > $summary->{count}) {
        $count = $summary->{count}; # 매도할 주식 수가 보유 주식 수보다 많으면 보유 주식 수로 조정
    }

    $summary->{deposit} += $count * $price; # 예수금에 추가

    print "Selling $count shares at $price on $date.\n";
    return {
        date => $date,
        price => $price,
        close => $vref->{close},
        count => -$count,
        amount => -$count * $price,
    };
}


###
sub buy {
    my($date, $stockData, $buyAmount, $summary) = @_;
    my $vref = $stockData->{$date};
    my $price = midPrice($vref);
    # open=300, close=200 => open + (close - open) / 2 = 300 + (200 - 300) / 2 = 300 + -100/2 = 300 - 50 = 250
    # open=200, close=300 => open + (close - open) / 2 = 200 + (300 - 200) / 2 = 200 + 100/2 = 200 + 50 = 250
    my $count = int($buyAmount / $price); # 주식 가치는 0일 수 없으므로 $price에 대한 검사는 하지 않음.
    if($count > $vref->{volume} / 10) {
        return undef; # 매수할 수 있는 주식 수가 너무 적음
    }
    print "Buying $count shares at $price on $date.\n";
    my $boughtAmount = $count * $price;
    if($boughtAmount > $summary->{deposit}) {
        my $diff = $boughtAmount - int($summary->{deposit});
        $summary->{moneyAdded} += $diff; # 추가 입금.
        $summary->{deposit} += $diff; # 예수금에도 추가.
    }

    $summary->{deposit} -= $boughtAmount; # 예수금에서 차감.

    return {
        date => $date,
        price => $price,
        close => $vref->{close},
        count => $count,
        amount => $count * $price,
    };
}

###
sub midPrice {
    my $vref = shift;
    return int($vref->{open} + ($vref->{close} - $vref->{open}) / 2);
}

###
sub readStockData {
    my $rollingHighPeriod = shift; # 롤링 최고가 기간
    my %data;
    while(<DATA>) {
        chomp;
        if(/^\d{4}/) {
            my($date, $open, $high, $low, $close, $volume) = map {s/,//g; $_} split /\t/, $_;

            if($high < $low || $open < $low || $close < $low || $open > $high || $close > $high) {
                die "Invalid stock data: $_";
            }
            my($year, $month, $day) = $date =~ /(\d{4})\D+(\d+)\D+(\d+)/;
            $date = sprintf("%04d-%02d-%02d", $year, $month, $day);
            $data{$date} = {
                open => $open,
                high => $high,
                low => $low,
                close => $close,
                volume => $volume,
                rollingHigh => 0,
            };
        }
        elsif(/^\w/) {
            my($date, $open, $high, $low, $close, $volume) = split /\t/, $_;
            if($date ne 'Date' || $open ne 'Open' || $high ne 'High' || $low ne 'Low' || $close ne 'Close' || $volume ne 'Volume') {
                die "Invalid header: $_";
            }
        }
    }
    # 롤링 최고가 계산
    my @dates = sort keys %data;
    foreach my $i (0..$#dates) {
        if($i >= $rollingHighPeriod - 1 && $rollingHighPeriod > 0) {
            # close 가격의 롤링 최고가를 계산
            my $min = $i - $rollingHighPeriod + 1;
            my $high = 0;
            foreach my $k ($min..$i) {
                my $date = $dates[$k];
                if($data{$date}->{close} > $high) {
                    $high = $data{$date}->{close};
                }
            }
            $data{$dates[$i]}->{rollingHigh} = $high;
        }
    }
    \%data;
}




(base) labisfun@labisfun-mac costav % yarn install
yarn install v1.22.10
[1/4] 🔍  Resolving packages...
[2/4] 🚚  Fetching packages...
[3/4] 🔗  Linking dependencies...
warning "@mui/material > @types/react-transition-group@4.4.12" has unmet peer dependency "@types/react@*".
warning "notistack > goober@2.1.16" has unmet peer dependency "csstype@^3.0.10".
warning "react-scripts > eslint-config-react-app > eslint-plugin-flowtype@8.0.3" has unmet peer dependency "@babel/plugin-syntax-flow@^7.14.5".
warning "react-scripts > eslint-config-react-app > eslint-plugin-flowtype@8.0.3" has unmet peer dependency "@babel/plugin-transform-react-jsx@^7.14.9".
warning "react-scripts > react-dev-utils > fork-ts-checker-webpack-plugin@6.5.3" has unmet peer dependency "typescript@>= 2.7".
warning "react-scripts > eslint-config-react-app > @typescript-eslint/eslint-plugin > tsutils@3.21.0" has unmet peer dependency "typescript@>=2.8.0 || >= 3.2.0-dev || >= 3.3.0-dev || >= 3.4.0-dev || >= 3.5.0-dev || >= 3.6.0-dev || >= 3.6.0-beta || >= 3.7.0-dev || >= 3.7.0-beta".
[4/4] 🔨  Building fresh packages...
success Saved lockfile.
✨  Done in 4.42s.

*/
